const initial_tv_kpis = ["BR", "HR", "SPO2", "PR", "SQ", "RII", "SE", "ODI", "bp", "blood_sugar", "body_temp", "weight"];

const validateSearchText = (evt) => {
    evt = (evt) ? evt : window.event;
    var charCode = (evt.which) ? evt.which : evt.keyCode;
    if (!(charCode > 47 && charCode < 58)
        && !(charCode > 64 && charCode < 91)
        && !(charCode > 96 && charCode < 123)
    ) {
        evt.preventDefault();
        return false;
    }

    if (evt.target.value.toString().length > 9) {
        evt.preventDefault();
        return false;
    }

    return true;
};

export {
    initial_tv_kpis,
    validateSearchText,
}
